import { render, staticRenderFns } from "./SignaturePopup.vue?vue&type=template&id=2495d510&scoped=true"
import script from "./SignaturePopup.vue?vue&type=script&lang=js"
export * from "./SignaturePopup.vue?vue&type=script&lang=js"
import style0 from "./SignaturePopup.vue?vue&type=style&index=0&id=2495d510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2495d510",
  null
  
)

export default component.exports